/* eslint-disable no-useless-catch */
import { axios } from "services/axios";
import Service from "../../service";

const AuthService = {
  getUserExist: async (token) => {
    try {
      return await Service.get(`/accounts/user/checkaccount`, token);
    } catch (error) {
      throw error;
    }
  },

  getDashboardSettings: async (token) => {
    try {
      return await Service.get(`/accounts/user/dashboard-settings`, token);
    } catch (error) {
      throw error;
    }
  },

  saveDashboardSettings: async (token, data) => {
    try {
      return await Service.update({ url: `/accounts/user/dashboard-settings`, data, token });
    } catch (error) {
      throw error;
    }
  },
  postFirstStep: async (data, token) => {
    try {
      return await Service.post({ url: "/setup", data, token });
    } catch (error) {
      throw error;
    }
  },

  getContactById: async (id, token) => {
    try {
      return await Service.get(`/accounts/contact/${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  postAddNewMember: async (data, token) => {
    try {
      return await Service.post({
        url: "/accounts/account/mainmember",
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  postAddNewAccount: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/account/", data, token });
    } catch (error) {
      throw error;
    }
  },
  postAddFamilyNewMember: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/contact/", data, token });
    } catch (error) {
      throw error;
    }
  },

  MergeTransaction: async (data, token) => {
    try {
      return await Service.post({ url: "/finance/v1/transaction/merge", data, token });
    } catch (error) {
      throw error;
    }
  },

  UpdateMergeTransaction: async (data, token) => {
    try {
      return await Service.update({ url: "/finance/v1/transaction/merge", data, token });
    } catch (error) {
      throw error;
    }
  },

  updateStep: async (data, token) => {
    try {
      return await Service.update({ url: "/setup", data, token });
    } catch (error) {
      throw error;
    }
  },
  downloadPresignURL: async (data, token) => {
    try {
      return await Service.getWithBody({ url: "/setup/presignningurl", data });
    } catch (error) {
      throw error;
    }
  },
  downloadBatchDocuments: async (fileName, token) => {
    try {
      return await Service.get(`accounts/setup/generate-get-url?Key=${fileName}`, token);
    } catch (error) {
      throw error;
    }
  },
  getFamilyMember: async (token) => {
    try {
      return await Service.get(`/accounts/account`, token);
    } catch (error) {
      throw error;
    }
  },
  deleteAccount: async (data, token) => {
    try {
      return await Service.remove({ url: `/accounts/account`, data, token });
    } catch (error) {
      throw error;
    }
  },

  getExportDeceased: async (token, sortBy) => {
    try {
      return await Service.get(
        `accounts/deceased/export/deceased?filter=${sortBy}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getFilteredDeceasedExport: async (filters, sortBy, token) => {
    try {
      return await Service.post({
        url: `accounts/deceased/export/deceased?filter=${sortBy}`,
        data: filters,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getDeceased: async (page, size, sort, token) => {
    try {
      return await Service.get(
        `/accounts/deceased?page=${page}&size=${size}${sort}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getDeceasedByMemberId: async (page, size, id, token) => {
    try {
      return await Service.post({
        url: `accounts/deceased/list/deceased?page=${page}&size=${size}&search=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getFilterdDeceased: async (page, size, filters, sortBy, token) => {
    try {
      return await Service.post({
        url: `/accounts/deceased/list/deceased?page=${page}&size=${size}&filter=${sortBy}`,
        data: filters,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getAllDeceased: async (token) => {
    try {
      return await Service.get(`/accounts/deceased?page=0&size=0`, token);
    } catch (error) {
      throw error;
    }
  },

  getAllDeceasedByAccountId: async (token, page, id) => {
    try {
      return await Service.get(
        `/accounts/deceased?page=${page}&size=6&search=${id}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  getDeceasedById: async (id, token) => {
    try {
      return await Service.post({ url: `/accounts/deceased/${id}`, token });
    } catch (error) {
      throw error;
    }
  },
  updateDeceased: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/deceased`, data, token });
    } catch (error) {
      throw error;
    }
  },
  postAddDeceased: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/deceased", data, token });
    } catch (error) {
      throw error;
    }
  },
  removeDeceased: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/deceased", data, token });
    } catch (error) {
      throw error;
    }
  },

  // Add Mourner to Deceased
  addMourner: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/deceased/add/mourner", data, token });
    } catch (error) {
      throw error;
    }
  },

  // Edit Mourner to Deceased
  updateMourner: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/deceased/update/mourner`, data, token });
    } catch (error) {
      throw error;
    }
  },
  getAccount: async (token) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${1}&size=${10000}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getAccountById: async (id, token) => {
    try {
      return await Service.get(`/accounts/account/${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  updateAccount: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/contact`, data, token });
    } catch (error) {
      throw error;
    }
  },

  postforgotpassword: async (data) => {
    try {
      return await Service.post({
        url: "/accounts/setup/reset-password",
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  updateAccountDetails: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/account`, data, token });
    } catch (error) {
      throw error;
    }
  },

  getFilterParams: async (token, adult = false) => {
    try {
      return await Service.get(`/accounts/filter/collectionparam/${adult ? '?adult=true' : ''}`, token);
    } catch (error) {
      throw error;
    }
  },

  getOperatorParams: async (token) => {
    try {
      return await Service.get("/accounts/filter/operator", token);
    } catch (error) {
      throw error;
    }
  },
  sendFilterParams: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/filter", data, token });
    } catch (error) {
      throw error;
    }
  },
  getMyFilterParams: async (id, token) => {
    try {
      return await Service.get(`/accounts/filter/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  removeFilter: async (data, token) => {
    try {
      return await Service.remove({ url: `/accounts/filter`, data, token });
    } catch (error) {
      throw error;
    }
  },
  getFilterById: async (id, token) => {
    try {
      return await Service.get(`/accounts/filter/display/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  editFilter: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/filter`, data, token });
    } catch (error) {
      throw error;
    }
  },

  postAddClass: async (data, token) => {
    try {
      return await Service.post({ url: "/schools/class", data, token });
    } catch (error) {
      throw error;
    }
  },
  updateClass: async (data, token) => {
    try {
      return await Service.update({ url: "/schools/class", data, token });
    } catch (error) {
      throw error;
    }
  },
  getClasses: async (token) => {
    try {
      return await Service.get(`/schools/class`, token);
    } catch (error) {
      throw error;
    }
  },
  getClassById: async (id, token) => {
    try {
      return await Service.get(`/schools/class/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getArchivedClasses: async (token) => {
    try {
      return await Service.get(`/schools/class/archive/archive`, token);
    } catch (error) {
      throw error;
    }
  },
  getCurrentClasses: async (token) => {
    try {
      return await Service.get(`/schools/class/archive/notarchive`, token);
    } catch (error) {
      throw error;
    }
  },
  getFormFields: async (token) => {
    try {
      return await Service.get(`/schools/form/field`, token);
    } catch (error) {
      throw error;
    }
  },
  getForms: async (token) => {
    try {
      return await Service.get(`/schools/form?show=1`, token);
    } catch (error) {
      throw error;
    }
  },

  postArchive: async (data, token) => {
    try {
      return await Service.post({ url: "/schools/class/archive", data, token });
    } catch (error) {
      throw error;
    }
  },
  postDuplicate: async (data, token) => {
    try {
      return await Service.post({
        url: "/schools/class/duplicate",
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getParticipants: async (id, token) => {
    try {
      return await Service.get(`/schools/participant/class/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  getParticipantsByAccount: async (id, token) => {
    try {
      return await Service.get(`/schools/participant/account/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  // /class/accountclass
  getClassesByAccount: async (id, token) => {
    try {
      return await Service.get(`/schools/class/accountclass/${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  updateMemberAccount: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/account`, data, token });
    } catch (error) {
      throw error;
    }
  },
  updateCommunicationSettings: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/org`, data, token });
    } catch (error) {
      throw error;
    }
  },
  updateOrgSettings: async (id, data, token) => {
    try {
      // return await Service.update({ url: `/accounts/${id}`, data, token });
      return await Service.update({ url: `/accounts/org`, data, token });
    } catch (error) {
      throw error;
    }
  },

  createInnvoice: async (token, data) => {
    try {
      return await Service.post({ url: "/finance/invoice", token, data });
    } catch (error) {
      throw error;
    }
  },
  getInvoices: async (token, data) => {
    try {
      return await Service.post("/accounts/invoice", token);
    } catch (error) {
      throw error;
    }
  },
  getNotesByAccountId: async (id, token) => {
    try {
      return await Service.get(`/accounts/notes?account_id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },
  createNote: async (data, token) => {
    try {
      return await Service.post({
        url: "/accounts/notes",
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  removeNote: async (data, token) => {
    try {
      return await Service.remove({ url: `/accounts/notes`, data, token });
    } catch (error) {
      throw error;
    }
  },
  editNote: async (data, token) => {
    try {
      return await Service.update({ url: `/accounts/notes`, data, token });
    } catch (error) {
      throw error;
    }
  },

  // add account tag
  addAccountTag: async (data, token) => {
    try {
      return await Service.update({ url: "/accounts/account/tag", data, token });
    } catch (error) {
      throw error;
    }
  },

  // delete account tag
  deleteAccountTag: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/account/tag", data, token });
    } catch (error) {
      throw error;
    }
  },

  // add contact tag
  addContactTag: async (data, token) => {
    try {
      return await Service.update({ url: "/accounts/contact/tag", data, token });
    } catch (error) {
      throw error;
    }
  },

  // delete contact tag
  deleteContactTag: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/contact/tag", data, token });
    } catch (error) {
      throw error;
    }
  },

  // delete event tag
  deleteEventTag: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/tag", data, token });
    } catch (error) {
      throw error;
    }
  },


  // get org tags
   getTags: async (type, id, search, token) => {
    try {
      return await Service.get(`/accounts/tag?type=${type}${id ? `&id=${id}` : ""}${search ? `&search=${search}` : ""}`, token);
    } catch (error) {
      throw error;
    }
  },
  // create org tag
  createTag: async (data, token) => {
    try {
      return await Service.post({ url: "/accounts/tag", data, token });
    } catch (error) {
      throw error;
    }
  },
  updateTag: async (data, token) => {
    try {
      return await Service.update({ url: "/accounts/tag", data, token });
    } catch (error) {
      throw error;
    }
  },
  deleteOrgTag: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/tag", data, token });
    } catch (error) {
      throw error;
    }
  },
  getTagUsage: async (id, token) => {
    try {
      return await Service.get(`/accounts/tag/usage?id=${id}`, token);
    } catch (error) {
      throw error;
    }
  },

  // Update  bulk tag
  updateBulkTag: async ({data, token}) => {
    try {
      return await Service.post({ url: "/accounts/tag/bulk", data, token });
    } catch (error) {
      throw error;
    }
  },

  downloadYahrzeits: async ({token,sortBy,filters}) => {
    try {
      return await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BASE_URL}/accounts/deceased/print/deceased/info?filter=${sortBy}`,
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
          Authorization: `Bearer ${token}`,
          "Access-Control-Expose-Headers": "Content-Disposition"
        },
        data:filters
      })
    } catch (error) {
      throw error;
    }
  },

  getDirectoryList: async (token, current_page, items_per_page, body = null) => {
    try {
      return await Service.post({
        url: `/accounts/account/directory?current_page=${current_page}&items_per_page=${items_per_page}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default AuthService;
